export default {
	categories: {
		report: {
			'antibody_barcoding': "Antibody barcoding",
			'antisaccade_task': "Antisaccade task",
			'body_fluid': "Body fluid",
			'canards_sign': "Canards sign",
			'cit_program_tumor_identity_cards': "CTI Program Tumor Identity Cards",
			'companion_diagnostic': "Companion diagnostic",
			'coordinated_diagnostics': "Coordinated diagnostics",
			'cosmed': "COSMED",
			'cryoglobulinemia': "Cryoglobulinemia",
			'diagnostic_overshadowing': "Diagnostic overshadowing",
			'differential_diagnosis': "Differential diagnosis",
			'directhit': "DirectHit",
			'dot_cancellation_test': "Dot Cancellation Test",
			'drehmann_sign': "Drehmann sign",
			'elbow_extension_test': "Elbow extension test",
			'electrophysiological_techniques_for_clinical_diagnosis': "Electrophysiological techniques for clinical diagnosis",
			'external_cause': "External cause",
			'fast_(stroke)': "FAST (stroke)",
			'fine-needle_aspiration': "Fine-needle aspiration",
			'flow-mediated_dilation': "Flow-mediated dilation",
			'frax': "FRAX",
			'gender-bias_in_medical_diagnosis': "Gender-bias in medical diagnosis",
			'immunolabeling': "Immunolabeling",
			'instantaneous_wave-free_ratio': "Instantaneous wave-free ratio",
			'laboratory_diagnosis_of_viral_infections': "Laboratory diagnosis of viral infections",
			'martha_mitchell_effect': "Martha Mitchell effect",
			'medical_findings': "Medical findings",
			'medical_laboratory': "Medical laboratory",
			'mental_status_examination': "Mental status examination",
			'microvesicles': "Microvesicles",
			'nasoendoscopy': "Nasoendoscopy",
			'nekrep_case': "Nekrep Case",
			'nucleic_acid_test': "Nucleic acid test",
			'oswestry_disability_index': "Oswestry Disability Index",
			'overdiagnosis': "Overdiagnosis",
			'paternity': "Paternity",
			'pericardiocentesis': "Pericardiocentesis",
			'photoacoustic_effect': "Photoacoustic effect",
			'prati_criteria': "Prati criteria",
			'pseudothrombocytopenia': "Pseudothrombocytopenia",
			'psychiatric_assessment': "Psychiatric assessment",
			'psychiatric_interview': "Psychiatric interview",
			'qns': "QNS",
			'radiopharmaceutical': "Radiopharmaceutical",
			'rectal_discharge': "Rectal discharge",
			'schooliosis': "Scoliosis",
			'surgical_sieve': "Surgical sieve",
			'sutton´s_law': "Sutton's law",
		},
		relations: {
			'other': "Other",
			'doctor': "Doctor",
			'father': "Father",
			'mother': "Mother",
			'son': "Son",
			'daughter': "Daughter",
		},
		diseases: {
			'alergias': "Allergies",
			'alzheimer´s_disease': "Alzheimer's Disease",
			'amyotrophic_lateral_sclerosis_(als)': "Amyotrophic Lateral Sclerosis (ALS)",
			'aneurisma': "Aneurisma",
			'ansiedade': "Anxiety",
			'arrhythmia_of_the_heart': "Arrhythmia of the Heart",
			'arthritis': "Arthritis",
			'asma': "Asma",
			'atrial_fibrillation': "Atrial Fibrillation",
			'autism': "Autism",
			'avc': "AVC",
			'bedsores_(pressure_ulcers)': "Bedsores (pressure ulcers)",
			'bipolar_disorder_(manic-depressive_illness)': "Bipolar Disorder (Manic-depressive illness)",
			'bócio': "Goiter",
			'cancer': "Cancer",
			'cataracts': "Cataracts",
			'cholesterol': "Cholesterol",
			'chronic_kidney_failure': "Chronic Kidney Failure",
			'coagulação_na_sangue': "Blood clotting",
			'copd,_or_chronic_obstructive_pulmonary_disease': "COPD, or Chronic Obstructive Pulmonary Disease",
			'depressão': "Depression",
			'diabetes': "Diabetes",
			'diminuição_auditiva': "Hearing impairment",
			'esquizofrenia': "Schizophrenia",
			'fibrilhação_auricular': "Atrial fibrillation",
			'fibromyalgia': "Fibromyalgia",
			'glaucoma': "Glaucoma",
			'heart_disease': "Heart Disease",
			'hepatitis': "Hepatitis",
			'hiv/aids': "HIV/AIDS",
			'hypertension_(high_blood_pressure)': "Hypertension (High Blood Pressure)",
			'hyperthyroidism_(overactive_thyroid)': "Hyperthyroidism (overactive thyroid)",
			'hypothyroidism_(underactive_thyroid)': "Hypothyroidism (underactive thyroid)",
			'incontinence,_urinary': "Urinary incontinence",
			'inflammatory_bowel_disease_(ibd)': "Inflammatory Bowel Disease (IBD)",
			'irritable_bowel_syndrome_(ibs)': "Irritable Bowel Syndrome (IBS)",
			'kidney_failure,_chronic': "Chronic Kidney Failure",
			'leukemia': "Leukemia",
			'liver_failure,_acute': "Acute Liver Failure",
			'liver_spots_(age_spots)': "Liver Spots (Age Spots)",
			'lupus': "Lupus",
			'lymphoma,_hodgkin´s_(hodgkin´s_disease)': "Lymphoma, Hodgkin's (Hodgkin's disease)",
			'lymphoma,_non-hodgkin´s': "Non-Hodgkin's Lymphoma",
			'macular_degeneration,_dry': "Dry Macular Degeneration",
			'mastectomia': "Mastectomy",
			'melanoma,_skin_cancer': "Melanoma, Skin Cancer",
			'multiple_sclerosis_(ms)': "Multiple Sclerosis (MS)",
			'obstructive_sleep_apnea': "Obstructive Sleep Apnea",
			'osteoarthritis': "Osteoarthritis",
			'osteoporosis': "Osteoporosis",
			'pancreatic_cancer': "Pancreatic Cancer",
			'parkinson´s_disease': "Parkinson's Disease",
			'periodontitis': "Periodontitis",
			'pneumonia': "Pneumonia",
			'post-traumatic_stress_disorder_(ptsd)': "Post-traumatic stress disorder (PTSD)",
			'psoriasis': "Psoriasis",
			'rheumatoid_arthritis': "Rheumatoid Arthritis",
			'rinite': "Rhinitis",
			'staph_infections': "Staph Infections",
			'stroke': "Stroke",
			'thrush,_oral': "Oral Thrush",
			'transient_ischemic_attack_(tia)': "Transient Ischemic Attack (TIA)",
			'tuberculosis_(tb)': "Tuberculosis (TB)",
			'ulcerative_colitis': "Ulcerative Colitis",
			'vascular_dementia': "Vascular Dementia",
			'vertigo': "Vertigo",
			'wrinkles': "Wrinkles",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/categories/categories_en-gb.js